import React from 'react';
import { Box, Typography } from '@mui/material';
import packageJson from '../../../package.json';
import { OFFICE, PRACTITIONER } from '../../config/site';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      className="layout-footer"
      sx={{
        background: 'linear-gradient(150deg, #201b14 0%, #2f281d 60%, #3a3125 100%)',
        color: 'rgba(250, 247, 242, 0.85)',
        px: 3,
        py: 5,
        textAlign: 'center',
        borderTop: '1px solid rgba(201, 169, 106, 0.35)',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'var(--font-display)',
          fontSize: '1.6rem',
          fontWeight: 600,
          letterSpacing: '0.12em',
          background: 'var(--luxe-gradient-gold)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          mb: 0.5,
        }}
      >
        ZEVA
      </Typography>
      <Typography
        sx={{
          fontFamily: 'var(--font-body)',
          fontSize: '0.85rem',
          letterSpacing: '0.05em',
          color: 'rgba(250, 247, 242, 0.9)',
          mb: 0.5,
        }}
      >
        {PRACTITIONER.name} — {PRACTITIONER.title}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'var(--font-body)',
          fontSize: '0.8rem',
          color: 'rgba(250, 247, 242, 0.6)',
          mb: 2.5,
        }}
      >
        {OFFICE.addressLine}
      </Typography>

      <Box
        sx={{
          width: '48px',
          height: '1px',
          background: 'var(--luxe-gradient-gold)',
          mx: 'auto',
          mb: 2.5,
          opacity: 0.7,
        }}
      />

      <Typography variant="body2" sx={{ fontSize: '0.72rem', color: 'rgba(250, 247, 242, 0.5)' }}>
        &copy; {new Date().getFullYear()} — Site créé en 2025 par Mohand-Ameziane ZAIDI
        pour {PRACTITIONER.name}. Tous droits réservés. Version {packageJson.version}
      </Typography>
    </Box>
  );
};

export default Footer;
